import Cta from './Cta.vue'
export default Cta



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Cta/index.js